import { useScrapingRatios } from '@/api/queries'
import type { ScrapingRatio } from '@/api/types'
import { DataTable, type Column } from '@/components/DataTable/DataTable'
import { LinkButton } from '@/components/ui/Button'
import { Icons } from '@/components/ui/Icons'
import { Modal } from '@/components/ui/Modal'
import { links } from '@/lib/links'

const columns: Column<ScrapingRatio>[] = [
  { key: 'posId', header: 'POS id', align: 'right' },
  { key: 'posName', header: 'POS' },
  { key: 'competitorId', header: 'Competitor id', align: 'right' },
  { key: 'competitorName', header: 'Competitor' },
  {
    key: 'search',
    header: '',
    sortable: false,
    width: '120px',
    render: (r) => (
      <LinkButton size="sm" href={links.googleHotelSearch(r.competitorName ?? '', r.posUri)} icon={<Icons.Search size={12} />}>
        Google
      </LinkButton>
    ),
  },
]

/** Competitors that returned nothing at all on a site: usually a renamed or delisted hotel. */
export function ScrapingRatiosDialog({ hours, onClose }: { hours: number; onClose: () => void }) {
  const { data, isLoading, error } = useScrapingRatios(hours)
  return (
    <Modal title={`Broken competitors · 100% not found (last ${hours}h)`} onClose={onClose} size="lg">
      <DataTable columns={columns} rows={data} rowKey={(r) => `${r.posId}:${r.competitorId}`} loading={isLoading} error={error} searchable searchPlaceholder="Search a POS or competitor" dense />
    </Modal>
  )
}
